import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";

const AdminLogin = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@zbeach.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Hoş geldiniz");
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Giriş başarısız");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-zbeach-bg px-6 grain relative overflow-hidden" data-testid="admin-login-page">
      <div className="absolute inset-0 opacity-30 pointer-events-none" style={{ background: "radial-gradient(60% 50% at 80% 20%, rgba(169,215,213,0.5), transparent 70%), radial-gradient(50% 40% at 10% 90%, rgba(169,130,74,0.25), transparent 70%)" }} />
      <div className="relative w-full max-w-md bg-zbeach-surface rounded-3xl p-8 shadow-xl border border-zbeach-gold/20">
        <div className="text-center mb-8">
          <div className="font-serif text-3xl tracking-wider text-gold-gradient font-semibold">Z BEACH</div>
          <p className="font-hand text-2xl text-zbeach-gold">Admin Panel</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-xs uppercase tracking-wider text-zbeach-muted mb-1.5">E-posta</label>
            <input
              type="email" required
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 rounded-xl bg-zbeach-bg border border-zbeach-gold/25 focus:outline-none focus:border-zbeach-turquoise"
              data-testid="login-email"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-wider text-zbeach-muted mb-1.5">Şifre</label>
            <input
              type="password" required
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 rounded-xl bg-zbeach-bg border border-zbeach-gold/25 focus:outline-none focus:border-zbeach-turquoise"
              data-testid="login-password"
            />
          </div>
          <button
            type="submit" disabled={loading}
            className="w-full py-3.5 rounded-xl bg-zbeach-turquoise text-white font-medium btn-glow disabled:opacity-50"
            data-testid="login-submit"
          >
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>
        </form>
        <p className="text-xs text-zbeach-muted text-center mt-6">Demo: admin@zbeach.com / admin123</p>
      </div>
    </div>
  );
};

export default AdminLogin;
